<template>
  <div class="radio-list">
    <h3 class="u-reset radio-list__title">
      {{ title }}
    </h3>

    <ui-model-provider v-slot="{ updateValue }" :value.sync="model">
      <ul class="u-reset radio-list__items">
        <li v-for="({ id, label }, idx) in items" :key="id" class="radio-list__item">
          <ui-radio
            :id="getUid(idx)"
            :checked="model === id"
            :value="id"
            :name="getUid()"
            @change="updateValue($event)"
          >
            <template #label>
              <span class="radio-list__label">
                {{ $t(label) }}
              </span>
            </template>
          </ui-radio>
        </li>
      </ul>
    </ui-model-provider>
  </div>
</template>

<script>
  import UiRadio from '@/components/form/ui-radio/ui-radio'
  import UiModelProvider from '@/components/form/ui-model-provider/ui-model-provider'
  import ariaMixin from '@/assets/js/mixin/aria'

  export default {
    components: { UiModelProvider, UiRadio },
    mixins: [ariaMixin('projection-selector')],
    props: {
      value: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      title: {
        type: String,
        default: null,
      },
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(model) {
          this.$emit('update:value', model)
        },
      },
    },
    methods: {
      getUid(id) {
        return this.ariaUid(null, id)
      },
    },
  }
</script>

<style lang="scss" src="./_radio-list.scss" />
